import React from 'react';
import {Button, Clearfix, DropdownButton, MenuItem, Panel, Table} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import ErrorComponent from '../ErrorComponent';
import GreenLeafApi from '../utils/GreenLeafApi';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import TablePager from '../TablePager';

class EngagementsPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      engagements: [],
      error: null,
      activePage: 1,
      maxPageItems: {value: 5, label: '5'},
    };
    this.fetchEngagements = this.fetchEngagements.bind(this);
  }

  componentDidMount() {
    try {
      this.fetchEngagements();
    } catch (e) {
      this.props.onError(e);;
    }
  }

  async fetchEngagements() {
    const engagements = await GreenLeafApi.Engagement.get({companyId: this.props.match.params.companyId});
    this.setState({engagements: engagements.data.engagements});
    
  }

  deleteEngagement = async (engagement) => {
    try{
      await GreenLeafApi.Engagement.delete(engagement.id);
      await this.fetchEngagements();
    } catch (e) {
      this.props.onError(e);
    }
  };

  getSponsorName(engagement) {
    return engagement.sponsor ? `${engagement.sponsor.first_name} ${engagement.sponsor.last_name}` : 'N/A';
  }

  handleMaxItemsChange = maxPageItems => {
    this.setState({maxPageItems});
    const maxPage = Math.ceil(this.state.engagement.length / maxPageItems.value);
    if(this.state.activePage > maxPage){
      this.setState({activePage: maxPage});
    }
  };

  changePage = (pageNum) => {
    this.setState({activePage: pageNum});
  };

  getTable = (engagements, offset) => {
    return(
      <Table responsive data-cy="engagement-table">
        <thead className='text-primary'>
        <tr>
          <th>#</th>
          <th>Sponsor</th>
          <th>Status</th>
          <th/>
        </tr>
        </thead>
        <tbody>
        {
          engagements.map((e, i) => {
            return(
              <tr key={i} className="item">
                <td>{offset+i+1}</td>
                <td>{this.getSponsorName(e)}</td>
                <td>{e.status}</td>
                <td align="right">
                  <DropdownButton
                    data-cy="item-dropdown-engagement"
                    id="item-dropdown"
                    title={<i className="fas fa-chevron-down"/>}
                    noCaret={true}
                    pullRight
                  >
                    <MenuItem data-cy="item-dashboard-button" onSelect={() => this.props.history.push(`/companies/${this.props.company_id}/engagements/${e.id}`)}>View</MenuItem>
                    <MenuItem data-cy="delete-item-button-engagement" onSelect={() => this.deleteEngagement(e)}>Delete</MenuItem>
                  </DropdownButton>
                </td>
              </tr>
            );
          })
        }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <div>
        <ErrorComponent error={this.state.error}/>
        <Panel>
          <Panel.Heading>
            <Panel.Title data-cy="engagements-panel" componentClass="h3" className={'relative'}>
              <div className={'float-vertical-align pull-left'}>Engagements</div>
              <div className={'pull-right'}>
                <Link className={'pull-right'} to={`/companies/${this.props.company_id}/engagements/create`}>
                  <Button data-cy="create-engagement" className={'primary'}>Create</Button>
                </Link>
              </div>
              <Clearfix/>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body data-cy="engagements-list">
            <TablePager data={this.state.engagements} dataTable={this.getTable}/>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

EngagementsPanel.propTypes = {
  company_id: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
};

export default withRouter(EngagementsPanel);



// WEBPACK FOOTER //
// ./src/components/engagement/EngagementsPanel.js